'use client'
import { useState, useEffect } from 'react'

import { ONE } from 'config/apis'
import { useTorContext } from 'utils/context'
import { capitalize, capitalizeString } from 'utils/strings'
import TableDropdown from 'components/TableDropdown'
import { dateToString } from 'utils/date'

const Registration = () => {
  const { tor } = useTorContext()
  const [registration, setRegistration] = useState()

  const getData = async () => {
    try {
      const req = await fetch(
        ONE.REGISTRATION.replace('{id}', tor.Info.Id),
        ONE.HEADERS
      )
      const parsed = await req.json()
      setRegistration(parsed.Data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className="max-w-3xl mx-auto">
      {registration && (
        <>
          <TableDropdown
            title="Categories"
            headers={['Categoria', 'Inscrits']}
            content={registration.Categories.map((item) => ({
              g: `${capitalize(item.Category)} ${capitalize(item.Gender)}`,
              t: item.TotalPlayers
            }))}
            cols={2}
          />
          <div className="mt-10">
            <TableDropdown
              title="Inscrits/es per clubs"
              headers={['Nom del club', 'Total Inscrits']}
              content={registration.TotalClubPlayers.map((item) => ({
                g: item.NameClub && capitalizeString(item.NameClub),
                t: item.TotalPayers
              }))}
              cols={2}
            />
          </div>
          <p className="text-[18px] lg:text-[25px] text-blue font-alliance-medium mt-14">
            {`Total parelles inscrites: ${registration?.TotalPlayers}`}
          </p>
        </>
      )}
      <div className="grid grid-cols-1">
        {registration &&
          registration.Categories.map((category, idx) => (
            <>
              <div className="flex mt-16 mb-6">
                <p className="truncate text-sm text-blue font-alliance-medium">{`${capitalize(
                  category.Category
                )} ${capitalize(category.Gender)}`}</p>
              </div>
              {category?.Players.map((team, idx) =>
                !team?.Team ? (
                  <div key={idx} className="flex items-center">
                    <p className="text-2xl font-bold text-blue w-10">
                      {idx + 1}
                    </p>
                    <div className="flex-1 mx-2 lg:mx-0">
                      <div className="grid grid-cols-1 lg:grid-cols-3 my-2 bg-sec-grey-4">
                        <div className="space-x-3 lg:pl-6 py-5 flex justify-center lg:justify-start">
                          <div
                            className={`relative flex items-center ${
                              team.PaidRegistration1 === 'false'
                                ? 'opacity-25'
                                : ''
                            }`}
                          >
                            <div className="flex-shrink-0">
                              <img
                                className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                                src={
                                  team.ImageLicense1 ||
                                  '/assets/images/players/no-photo.svg'
                                }
                                alt=""
                              />
                            </div>
                            <div className="min-w-0 flex-1">
                              <span
                                className="absolute inset-0"
                                aria-hidden="true"
                              />
                              <div>
                                <p className="text-sm font-bold text-blue ml-5 mb-0 p-0">
                                  {capitalizeString(team.Name1)}
                                </p>
                                {team.PaidRegistration1 === 'false' && (
                                  <p className="text-sm font-bold text-blue mt-0 ml-5 p-0">
                                    No inscrit
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center items-center">
                          <p className="text-2xl font-bold text-blue">
                            {team.Points}
                          </p>
                        </div>
                        <div className="space-x-3 lg:pr-6 py-5 flex justify-center lg:justify-start">
                          <div
                            className={`relative flex items-center ${
                              team.PaidRegistration2 === 'false'
                                ? 'opacity-25'
                                : ''
                            }`}
                          >
                            <div className="flex-shrink-0">
                              <img
                                className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                                src={
                                  team.ImageLicense2 ||
                                  '/assets/images/players/no-photo.svg'
                                }
                                alt=""
                              />
                            </div>
                            <div className="min-w-0 flex-1">
                              {/* <a href="#" className="focus:outline-none"> */}
                              <span
                                className="absolute inset-0"
                                aria-hidden="true"
                              />
                              <div>
                                <p className="text-sm font-bold text-blue ml-5 mb-0 p-0">
                                  {capitalizeString(team.Name2)}
                                </p>
                                {team.PaidRegistration2 === 'false' && (
                                  <p className="text-sm font-bold text-blue mt-0 ml-5 p-0">
                                    No inscrit
                                  </p>
                                )}
                              </div>
                              {/* </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="mt-10" key={idx}>
                    {team && (
                      <TableDropdown
                        title={`${capitalizeString(team.Team)} - ${
                          team.Points
                        }<br/>${capitalizeString(team.CaptainName)}`}
                        headers={[
                          'Nom',
                          '',
                          'Categoria',
                          'Data de naixement',
                          'Punts'
                        ]}
                        content={(team.PlayersDetails || []).map((item) => ({
                          0: item.Name,
                          2: item.Category,
                          3: dateToString(item.birthdate).withYear,
                          4: item.Points
                        }))}
                        cols={5}
                        extraClass={{ 0: 'col-span-2' }}
                      />
                    )}
                  </div>
                )
              )}
            </>
          ))}
      </div>
    </div>
  )
}

export default Registration
